/**
 * Live-search guard (2026-09-16, leak 3, B-234).
 *
 * A tiny shared counter: how many live searches are streaming in this tab
 * right now. ComparisonStream raises it while its stream is open and lowers
 * it when the stream ends or the component unmounts. StaleBuildWatcher
 * reads it and never reloads the tab over a live search.
 *
 * Why: on 16 Sep 2026 06:13 Sydney a running ASKO search was cut by the
 * deploy version-check reload (the tab reloads itself once when the server
 * build id changes). The reload closed the stream and the search had to
 * be restarted from zero two minutes later. The server now keeps a search
 * alive across a disconnect (api run_registry), but a reload that can wait
 * five minutes should simply wait.
 *
 * Module state, not storage: both readers live in the same bundle and a
 * reload resets it, which is exactly right (nothing streams after one).
 */
let running = 0;

export function beginLiveSearch(): void {
  running += 1;
}

export function endLiveSearch(): void {
  running = Math.max(0, running - 1);
}

export function isLiveSearchRunning(): boolean {
  return running > 0;
}
